
import { defineComponent, onBeforeMount, reactive } from 'vue'

// @components
import NewButton from '@/ui-kit/NewButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// @types
import { InvoiceT } from '@/new-services/types/containers'

// @realisations
import containersAPI from '@/new-services/containers.service'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        NewButton,
        Loader,
        TheInput,
        Cheap,
    },
    props: {
        invoiceId: {
            type: Number,
            required: true,
        },
    },
    emits: ['cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            invoice: null as InvoiceT | null,
            sla_date: null as string | null,
        })

        const form = reactive({
            invoiceNumber: null as string | null,
            weight: null as number | null,
            volumeWeight: null as number | null,
            createdAt: null as string | null,
            deliveryDate: null as string | null,
            deliveryStatus: null as string | null,
        })

        const fillInfo = (data: InvoiceT) => {
            if (!data) return

            state.invoice = data

            form.invoiceNumber = data.invoiceNumber
            form.weight = data.weight
            form.volumeWeight = data.volumeWeight
            form.createdAt = data.createdAt
            form.deliveryDate = data.deliveryDate
            if (data.deliveryStatus) {
                form.deliveryStatus = data.deliveryStatus.title
            }
        }

        const loadInvoice = async () => {
            try {
                state.is_loading = true

                const response = await containersAPI.getInvoice(props.invoiceId)
                fillInfo(response.data.data)

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении данных накладной произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const emitCancel = () => {
            emit('cancel')
        }

        //

        onBeforeMount(() => {
            loadInvoice()
        })

        //

        return {
            state,
            form,
            //
            loadInvoice,
            emitCancel,
        }
    },
})
